import { useState, useEffect } from 'react'
import { AdminAlert, AdminButton, isNotBuiltYet } from '../AdminShared'
import { adminGetAllSettings, adminUpdateStakingSettings } from '../../../services/admin'

export function StakingSettings() {
  const [minimumStakeAmount, setMinimumStakeAmount] = useState(100)
  const [saved, setSaved] = useState(100)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)
  const [successMsg, setSuccessMsg] = useState(null)

  useEffect(() => {
    setLoading(true)
    adminGetAllSettings()
      .then(data => {
        const value = data?.stakingSettings?.minimumStakeAmount ?? 100
        setMinimumStakeAmount(value)
        setSaved(value)
      })
      .catch(err => { if (!isNotBuiltYet(err)) setError(err.message) })
      .finally(() => setLoading(false))
  }, [])

  const isDirty = Number(minimumStakeAmount) !== Number(saved)

  const handleSave = async () => {
    setSaving(true)
    setError(null)
    try {
      const result = await adminUpdateStakingSettings({ minimumStakeAmount: Number(minimumStakeAmount) })
      const value = result?.value?.minimumStakeAmount ?? Number(minimumStakeAmount)
      setSaved(value)
      setMinimumStakeAmount(value)
      setSuccessMsg('Staking settings saved.')
      setTimeout(() => setSuccessMsg(null), 3000)
    } catch (err) {
      setError(err.message ?? 'Failed to save staking settings')
    } finally {
      setSaving(false)
    }
  }

  if (loading) {
    return <div className="h-40 bg-surface border-4 border-on-background animate-pulse" />
  }

  return (
    <div className="flex flex-col gap-6">
      {error && <AdminAlert type="error" message={error} />}
      {successMsg && <AdminAlert type="success" message={successMsg} />}

      <div className="border-4 border-on-background bg-surface p-5 flex flex-col gap-4"
        style={{ boxShadow: '5px 5px 0px 0px var(--neo-border-color)' }}>
        <h3 className="font-extrabold text-[13px] uppercase tracking-wider">Minimum Stake Amount</h3>
        <p className="text-[12px] text-on-surface-variant">
          The minimum amount of CPT a user must stake to participate in staking rewards.
        </p>
        <div className="flex flex-col gap-1 max-w-xs">
          <label className="font-bold text-[10px] uppercase tracking-widest text-on-surface-variant">Minimum Stake Amount</label>
          <input
            type="number" min="0" step="1"
            value={minimumStakeAmount}
            onChange={e => setMinimumStakeAmount(e.target.value)}
            className="bg-surface border-2 border-on-background px-3 py-2 font-mono text-[14px] focus:outline-none focus:border-primary-container"
          />
        </div>
      </div>

      <div className="flex gap-3">
        <div className="flex-1">
          <AdminButton onClick={handleSave} loading={saving} disabled={!isDirty || loading} variant="gold">
            <span className="material-symbols-outlined text-[16px]">save</span>
            Save Settings
          </AdminButton>
        </div>
        <div className="w-40">
          <AdminButton onClick={() => setMinimumStakeAmount(saved)} disabled={!isDirty || loading || saving} variant="outline">
            Discard
          </AdminButton>
        </div>
      </div>
    </div>
  )
}